import { Injectable } from '@angular/core'
import { environment } from '@environments/environment'
import { TemplateNavigationItem } from '../models/template-navigation-item.model'
import { AbstractContentSidebarStateService } from './abstract-content-sidebar-state.service'

@Injectable({
  providedIn: 'root'
})
export class TemplateStateService extends AbstractContentSidebarStateService<TemplateNavigationItem> {
  protected override readonly apiUrl = environment.templateApiUrl
  protected override readonly subsystemName = 'Template List Loading'
  protected override readonly errorDescription = 'Could not load the list of Templates.'
}
